import { Component, ChangeDetectionStrategy, inject, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';

import { version } from '../VERSION';

/**
 * Root component: hosts the router outlet and publishes the release version as `<meta name="version">`
 */
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {
  private meta = inject(Meta);

  /**
   * Writes the version from `src/VERSION.ts` into the document head, so a deployed page can be matched to its release
   */
  ngOnInit(): void {
    this.meta.updateTag({ name: 'version', content: version });
  }
}
